import styled from '@emotion/styled'
import {COLORS} from '../constants'

/** Horizontal, wrapping bar that holds the legend title and colour items. */
export const Legend = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 16px;
  padding: 8px 16px;
  border: 1px solid ${COLORS.border};
  border-radius: 8px;
  background-color: ${COLORS.mutedBg};
  font-size: 12px;
  color: ${COLORS.mutedText};
`

/** Emphasised "Legend" label at the start of the bar. */
export const LegendTitle = styled.span`
  font-weight: 600;
  color: ${COLORS.foreground};
`

/** A single legend entry — a colour swatch paired with its label. */
export const LegendItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`

/** Small rounded colour chip; its background colour is set per item inline. */
export const Swatch = styled.span`
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 3px;
`
